import { Base64 } from 'js-base64';
import { setLtiLaunch } from '../lib/axios';

import { isAppInIframe } from '../lib/utils';
import { APPLICATION_MODE } from '../constants/layout';

export const INITIALIZE_PAYLOAD = 'INITIALIZE_PAYLOAD';
export const INITIALIZE_ERROR = 'INITIALIZE_ERROR';
export const RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE';
export const STARTPAGE_CHECKBOX_CLICK = 'STARTPAGE_CHECKBOX_CLICK';
export const APP_LOADED_PENDING = 'APP_LOADED_PENDING';
export const APP_LOADED_COMPLETED = 'APP_LOADED_COMPLETED';
export const APP_LOADED_ERROR = 'APP_LOADED_ERROR';
export const INIT_GOOGLE_COURSE_ID = 'INIT_GOOGLE_COURSE_ID';

export function initializeApplication(executionMode) {
    const urlParams = new URLSearchParams(window.location.search);
    const encodedPayload = urlParams.get('payload');
    const platform = urlParams.get('platform');
    const isLtiLaunch = urlParams.get('lti-launch') === 'true';

    return async (dispatch) => {
        try {
            const payload = JSON.parse(Base64.decode(encodedPayload));

            dispatch({ type: RESET_TO_INITIAL_STATE });
            // Clean URL
            window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
            // TODO: da rimuovere quando rivediamo i payload dei link
            if (isLtiLaunch) {
                setLtiLaunch();
            }

            let showStartPage;
            if (payload.profile.time > 0) {
                showStartPage = true;
            } else {
                const profileName = payload.profile.name;
                showStartPage =
                    profileName && localStorage.getItem(`showStartPage-${profileName.toLowerCase()}`)
                        ? localStorage.getItem(`showStartPage-${profileName.toLowerCase()}`) === 'true'
                        : true;
            }
            if (payload.mode === APPLICATION_MODE.EMBEDDED) {
                showStartPage = false;
            }

            const scoreModifier = payload.profile.scoreModifier;

            const profile = {
                encodedPayload,
                ...payload,
                ...payload.profile,
                showStartPage,
                executionMode,
                isEmbedded: isLtiLaunch || isAppInIframe(),
            };
            delete profile.profile;
            delete profile.scoreModifier;

            dispatch({ type: INITIALIZE_PAYLOAD, payload: profile, isLtiLaunch, platform });

            return { profile, scoreModifier };
        } catch {
            dispatch({ type: INITIALIZE_ERROR, isLtiLaunch });
            return 'Empty payload';
        }
    };
}

export function onStartPageCheckboxClick(isSelected) {
    return {
        type: STARTPAGE_CHECKBOX_CLICK,
        payload: isSelected,
    };
}

export const TOGGLE_HINTBOX = 'TOGGLE_HINTBOX';

export function toggleHintBox(exerciseType) {
    return {
        type: TOGGLE_HINTBOX,
        payload: exerciseType,
    };
}

export const PROFILE_NAME = 'PROFILE_NAME';

export function setProfileName(name) {
    return {
        type: PROFILE_NAME,
        payload: name,
    };
}

export function appLoadedPending() {
    return {
        type: APP_LOADED_PENDING,
    };
}

export function appLoadedCompleted() {
    return {
        type: APP_LOADED_COMPLETED,
    };
}

export function setGoogleCourseWorkId(googleCourseWorkId = 'default') {
    return {
        type: INIT_GOOGLE_COURSE_ID,
        payload: googleCourseWorkId,
    };
}
